(function (root) {
  'use strict';
  const marker = '_mamata_auto_gift';

  // One ribbon per eligible box. Never change ribbons intentionally purchased.
  function giftPlan(cart, config) {
    const boxes = cart.items.filter(item => config.eligibleProductIds.includes(item.product_id)).reduce((sum, item) => sum + item.quantity, 0);
    const ribbons = cart.items.filter(item => item.variant_id === config.variantId);
    const manual = ribbons.filter(item => item.properties?.[marker] !== 'cofanetto').reduce((sum, item) => sum + item.quantity, 0);
    const automatic = ribbons.filter(item => item.properties?.[marker] === 'cofanetto');
    const wanted = Math.max(0, boxes - manual);
    const updates = {};
    automatic.forEach((item, index) => {
      const quantity = index === 0 ? wanted : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return { boxes, wanted, updates, add: automatic.length === 0 && wanted > 0 && config.available ? wanted : 0 };
  }
  root.MamataGiftLogic = { giftPlan, marker };
  if (typeof module !== 'undefined') module.exports = root.MamataGiftLogic;
  if (!root.document) return;
  const element = document.getElementById('MamataGiftConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  if (!config.enabled || !config.variantId || !config.eligibleProductIds.length) return;
  let active = null;
  let dirty = false;
  let checkoutResume = false;

  function message(text) {
    const status = document.getElementById('MamataGiftStatus');
    if (status) { status.textContent = text; status.hidden = !text; }
  }
  async function request(endpoint, body) {
    const response = await fetch(config.root + endpoint, {
      method: body ? 'POST' : 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {}), cache: 'no-store'
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Carrello non disponibile');
    return data;
  }
  function sections() {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
    return [...new Set(sections)].slice(0, 5);
  }
  function publish(cart, rendered) {
    if (rendered && root.FoxTheme?.pubsub) {
      cart.sections = rendered;
      root.FoxTheme.pubsub.publish(root.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { sources: 'mamata-gift', cart });
    }
  }
  async function reconcile() {
    let cart = await request('cart.js');
    const plan = giftPlan(cart, config);
    const render = { sections: sections(), sections_url: location.pathname };
    let rendered;
    if (Object.keys(plan.updates).length) {
      cart = await request('cart/update.js', { updates: plan.updates, ...render });
      rendered = cart.sections;
    }
    if (plan.add) {
      const added = await request('cart/add.js', { items: [{ id: config.variantId, quantity: plan.add, properties: { [marker]: 'cofanetto' } }], ...render });
      rendered = added.sections;
      cart = await request('cart.js');
    }
    const charged = cart.items.filter(item => item.variant_id === config.variantId && item.properties?.[marker] === 'cofanetto' && item.final_line_price > 0);
    if (charged.length) {
      // A disabled/conflicting promotion must never leave an automatically added paid ribbon.
      const updates = Object.fromEntries(charged.map(item => [item.key, 0]));
      cart = await request('cart/update.js', { updates, ...render });
      publish(cart, cart.sections);
      message('Non siamo riusciti ad applicare l’omaggio. Il nastro non è stato addebitato; riprova prima di proseguire.');
      return false;
    }
    publish(cart, rendered);
    message('');
    return cart;
  }
  function sync() {
    if (active) { dirty = true; return active; }
    active = (async () => {
      let result;
      let passes = 0;
      do {
        dirty = false;
        result = await reconcile();
        passes++;
      } while (dirty && result && passes < 4);
      return result;
    })().catch(error => {
      message('Non siamo riusciti ad aggiornare l’omaggio. Riprova prima di proseguire al pagamento.');
      console.error('Mamata gift:', error.message);
      return false;
    }).finally(() => { active = null; });
    return active;
  }
  root.MamataGift = { sync };
  function init() {
    root.FoxTheme?.pubsub.subscribe(root.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.sources !== 'mamata-gift') sync();
    });
    if (config.initialItemCount) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('submit', async event => {
    const button = event.submitter;
    if (checkoutResume || !button || button.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.target;
    button.disabled = true;
    const ok = await sync();
    button.disabled = false;
    if (ok) {
      // Rendering a changed gift can replace the original form or submit button.
      const currentForm = form.isConnected ? form : document.getElementById(form.id);
      const currentButton = button.isConnected ? button : currentForm && Array.from(currentForm.elements).find(input => input.name === 'checkout');
      if (!currentForm || !currentButton) {
        message('Carrello aggiornato. Premi di nuovo il pulsante per proseguire al pagamento.');
        return;
      }
      checkoutResume = true;
      currentButton.disabled = false;
      currentForm.requestSubmit(currentButton);
      checkoutResume = false;
    }
  }, true);
  document.addEventListener('click', async event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || checkoutResume) return;
    const url = new URL(anchor.href, location.origin);
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}\/)?checkouts?(?:\/|$)/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (await sync()) location.assign(anchor.href);
  }, true);
})(typeof window !== 'undefined' ? window : globalThis);
